import React, { useState, useEffect } from "react";
import DealershipsList from "../components/DealershipsList";
import ModalDealershipDetails from "../components/ModalDealershipDetails";
import MapContent from "../components/MapContent";
import useGetTranslations from "../hooks/useGetTranslations";
import Axios from "axios";

const initialMapState = {
    isLoading: false,
    centerAt: { coords: { lat: -33.4488897, lng: -70.6692655 } },
    selectedMarker: null,
    userLocation: null,
    showResults: false,
    mapConfig: {
        zoom: 10,
    },
};

const DealersMap = ({ locale }) => {
    const [mapState, setMapState] = useState(initialMapState);
    const [dealerships, setDealerships] = useState([]);
    const [translations] = useGetTranslations(
        "/api/dealers/get_translations/"
    );

    useEffect(() => {
        Axios.get(`/api/dealers/branches/`, {
            headers: {
                "Accept-Language": locale,
            },
        })
            .then((response) => {
                initData(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const initData = (data) => {
        setDealerships(data);
    };

    const onItemClick = (e, item) => {
        item.coords = {
            lat: Number(item.coords.lat),
            lng: Number(item.coords.lng),
        };
        setMapState((prevState) => ({
            ...prevState,
            selectedMarker: item,
            centerAt: item,
            mapConfig: {
                zoom: 16,
            },
        }));
    };

    const clearSelectedMarker = () => {
        setMapState((prevState) => ({
            ...prevState,
            selectedMarker: null,
        }));
    };

    const getGeoLocationData = () => {
        if (navigator && navigator.geolocation) {
            // Geolocation can take a couple seconds on WiFi
            //   setState({ isLoading: true });

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLocation = {
                        id: "userMarker",
                        latitud: position.coords.latitude,
                        longitud: position.coords.longitude,
                        coords: {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        },
                        nombre: "Tu ubicación",
                        numero: "",
                    };

                    const zoomLevel = window.innerWidth <= 768 ? 15 : 20;

                    setMapState((prevState) => ({
                        centerAt: userLocation,
                        selectedMarker: null,
                        userLocation: userLocation,
                        mapConfig: { ...prevState.mapConfig, zoom: zoomLevel },
                    }));
                },
                (error) => {
                    // Blocked
                    alert(translations.text3);
                    console.log("location error", error);
                }
            );
        } else {
            // Browser doesn't support Geolocation
            alert(translations.text4);
            console.log("Browser does not support Geolocation");
        }
    };

    return (
        <div className="map-branches-container">
            <div className="title-and-button">
                <div className="wrapper">
                    <span className="text">
                        <div className="title">{translations.text2}</div>
                    </span>
                    <button
                        type="button"
                        className="btn-large btn-primary-black with_icon"
                        onClick={getGeoLocationData}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_2174_1937)">
                                <path
                                    d="M7.99996 7.99992C7.26663 7.99992 6.66663 7.39992 6.66663 6.66659C6.66663 5.93325 7.26663 5.33325 7.99996 5.33325C8.73329 5.33325 9.33329 5.93325 9.33329 6.66659C9.33329 7.39992 8.73329 7.99992 7.99996 7.99992ZM12 6.79992C12 4.37992 10.2333 2.66659 7.99996 2.66659C5.76663 2.66659 3.99996 4.37992 3.99996 6.79992C3.99996 8.35992 5.29996 10.4266 7.99996 12.8933C10.7 10.4266 12 8.35992 12 6.79992ZM7.99996 1.33325C10.8 1.33325 13.3333 3.47992 13.3333 6.79992C13.3333 9.01325 11.5533 11.6333 7.99996 14.6666C4.44663 11.6333 2.66663 9.01325 2.66663 6.79992C2.66663 3.47992 5.19996 1.33325 7.99996 1.33325Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2174_1937">
                                    <rect width="16" height="16" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        {translations.text1}
                    </button>
                </div>
            </div>

            <div className="map-content">
                <MapContent
                    mapState={mapState}
                    dealerships={dealerships}
                    onItemClick={onItemClick}
                    clearSelectedMarker={clearSelectedMarker}
                />
                {mapState.selectedMarker !== null ? (
                    <ModalDealershipDetails
                        selectedMarker={mapState.selectedMarker}
                        clearSelectedMarker={clearSelectedMarker}
                    />
                ) : (
                    <DealershipsList
                        onItemClick={onItemClick}
                        dealerships={dealerships}
                    />
                )}
            </div>
        </div>
    );
};

export default DealersMap;
